<div class="app-modal-spinner facesheet">
    <header class="edit-header">
        <h1>編集</h1>
    </header>
    <div class="container" *ngIf="record">
        <!--  -->
        <mat-expansion-panel class="mat-elevation-z0" [expanded]="!collapsed" [disabled]="!collapsed">
            <mat-expansion-panel-header>
                <header>
                    <h2 class="user">{{dai?.name || record?.objnm}}</h2>
                    <p class="history">
                        <span>帳票履歴：{{record?.sdate | date: "yyyy年MM月dd日 (EEE)" }}</span>
                    </p>
                </header>
            </mat-expansion-panel-header>
            <div class="checkbox-field">
                <mat-checkbox [formControl]="handover" disableRipple (change)="onChange()">申し送り</mat-checkbox>
                <mat-checkbox [formControl]="summary" disableRipple (change)="onChange()">サマリー</mat-checkbox>
            </div>
            <!--  -->
            <div class="form-field">
                <span class="form-field-label">
                    対象
                </span>
                <div class="inner">
                    <input matInput (change)="onChange()" [value]="dai?.name" [disabled]="true" />
                </div>
            </div>

            <app-datetime-field label="開始日時" [form]="startDate"
                (formChange)="[startDateChange(), compareDate(), onChange()]"></app-datetime-field>
            <div [style]="{height: '24px', width: '100%'}"></div>
            <app-datetime-field label="終了日時" [form]="endDate" (formChange)="[compareDate(), onChange()]"
                [disabled]="!isDecide">
                <mat-error *ngIf="endDate.hasError('compareDate')">終了日時は開始日時より後の日時を入力してください</mat-error>
            </app-datetime-field>
            <div class="checkbox-field">
                <mat-checkbox disableRipple (change)="changeDecide($event)" [checked]="!isDecide">未定</mat-checkbox>
            </div>
            <!-- select -->
            <app-select-item [label]="'期間'" [options]="durationOptions" [placeholder]="''" [currentValue]="dateDuration"
                (onChange)="changeEndDate($event)" [currentValue]="currentDuration"></app-select-item>
            <!-- <app-select-item [label]="'記録者'" [options]="ownStfOptions"
                [currentValue]="profile?.staffCode"></app-select-item> -->
            <div class="form-field">
                <span class="form-field-label">
                    記録者
                </span>
                <div class="inner">
                    <input matInput (change)="onChange()" [value]="profile?.fullName" [disabled]="true" />
                </div>
            </div>
            <app-select-item [label]="'ユニット'" [options]="unitOptions" [currentValue]="currentUnit"
                (onChange)="changeUnit($event)"></app-select-item>
        </mat-expansion-panel>
        <!--  -->
        <!-- <div class="button-group">
            <button mat-button type="button" class="edit-button">
                ツール<mat-icon svgIcon="wrench"></mat-icon>
            </button>
        </div> -->
        <div class="title" #titleform *ngIf="noteTitleParams">
            <lib-note-title [params]="noteTitleParams" #notetitle></lib-note-title>
        </div>
        <footer class="edit-footer">
            <button type="button" mat-button class="cancel" (click)="cancel()">
                キャンセル
            </button>
            <button mat-button class="excute" (click)="submit()" [disabled]="isDecide && !isValid ">
                保存
            </button>
        </footer>
    </div>
</div>
